import { createAsyncThunk } from '@reduxjs/toolkit'

import { IWalletEventMetadata, IWalletEventTicketCode } from 'meta/pages/v4/wallet'
import { WalletController } from 'controller/wallet'
import { RootState } from 'store/types'

interface Params {
  eventIdOrCodeUrl: string
  page: number
}

type Returned = { items: Array<IWalletEventTicketCode>; metadata: IWalletEventMetadata; eventIdOrCodeUrl: string }

export const getEventTicketCodes = createAsyncThunk<Returned, Params, { state: RootState }>(
  'wallet/event/tickets/codes',
  async (params) => {
    const { eventIdOrCodeUrl, page } = params

    const { items, metadata } = await WalletController.getEventTicketCodes({ eventIdOrCodeUrl, page })

    return { items, metadata, eventIdOrCodeUrl: eventIdOrCodeUrl }
  }
)
